import PropTypes from 'prop-types';
export var THEME_PROP_TYPE = PropTypes.object;